import { IGetSplashImages, types } from './types';
import { createAction } from '@reduxjs/toolkit';

export const getSplashImages = createAction(types.GET_SPLASH_IMAGES);
export const getSplashImageSuccess = createAction<IGetSplashImages>(types.GET_SPLASH_IMAGES_SUCCESS);
export const getSplashImageFailed = createAction(types.GET_SPLASH_IMAGES_FAILED);
